export default "__VITE_ASSET__CwVlKz1j__"